'use strict';
define([
    'angular',
    'modules/settings/invitations/invitations.controller',
],function(angular, InvitationsController){
    var app = angular.module('settings.invitations', []);
    app.controller('InvitationsController', InvitationsController);
    return app;
});